// extracted by mini-css-extract-plugin
export var btn = "BannerContainer-module--btn--LxFEr";
export var container = "BannerContainer-module--container--L31aD";
export var img = "BannerContainer-module--img--4kz+n";
export var section = "BannerContainer-module--section--2DokK";
export var subtitle = "BannerContainer-module--subtitle--I9AUW";
export var text = "BannerContainer-module--text--eZ3ro";
export var title = "BannerContainer-module--title--9Tdke";